import {
  SHOW_NOTICE_TEMPLATE_MODAL,
  SHOW_SEND_NOTICE_MODAL,
  HIDE_NOTICE_TEMPLATE_MODAL,
  HIDE_SEND_NOTICE_MODAL,
  SHOW_CARRIER_MODAL,
  HIDE_CARRIER_MODAL,
  SHOW_CARRIER_BUS_MODAL,
  HIDE_CARRIER_BUS_MODAL,
  HIDE_CARRIER_DRIVER_MODAL,
  SHOW_CARRIER_DRIVER_MODAL,
  SHOW_SELECT_BUSES_AND_DRIVERS_MODAL,
  HIDE_SELECT_BUSES_AND_DRIVERS_MODAL,
  NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS,
  NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE,
  CREATE_DRIVER,
  REMOVE_DRIVER,
  UPDATE_DRIVER,
  UPDATE_DRIVER_SUCCESS,
  REMOVE_DRIVER_SUCCESS,
  CREATE_DRIVER_SUCCESS,
  UPDATE_DRIVER_FAILURE,
  CREATE_BUS,
  UPDATE_BUS,
  REMOVE_BUS,
  CREATE_BUS_SUCCESS,
  UPDATE_BUS_SUCCESS,
  REMOVE_BUS_SUCCESS,
  UPDATE_BUS_FAILURE,
  ADD_NOTICE_TEMPLATE,
  EDIT_NOTICE_TEMPLATE,
  UPDATE_ROUTE_RELATIONS_FAILURE,
  UPDATE_ROUTE_RELATIONS_SUCCESS,
  UPDATE_ROUTE_RELATIONS,
  CREATE_CARRIER,
  REMOVE_CARRIER,
  UPDATE_CARRIER_DETAILS,
  CREATE_CARRIER_SUCCESS,
  REMOVE_CARRIER_SUCCESS,
  UPDATE_CARRIER_DETAILS_SUCCESS,
  UPDATE_CARRIER_FAILURE,
  SHOW_DEACTIVATE_ACCOUNT_MODAL,
  HIDE_DEACTIVATE_ACCOUNT_MODAL,
  SHOW_DELETE_ACCOUNT_MODAL,
  HIDE_DELETE_ACCOUNT_MODAL,
  SHOW_ADD_ACCOUNT_MODAL,
  HIDE_ADD_ACCOUNT_MODAL,
  SHOW_ADD_STUDENT_FORM,
  HIDE_ADD_STUDENT_FORM,
  GET_STUDENT_INFO,
  GET_STUDENT_INFO_SUCCESS,
  GET_STUDENT_INFO_ERROR,
  SHOW_PARENT_STAFF_MODAL,
  HIDE_PARENT_STAFF_MODAL,
  SEARCH_USERS_FORM,
  SEARCH_USERS_FORM_SUCCESS,
  SEARCH_USERS_FORM_ERROR,
  SHOW_HISTORY_MAP_MODAL,
  HIDE_HISTORY_MAP_MODAL,
  ERROR_MODAL,
  HIDE_ERROR_MODAL,
} from 'constants/ActionTypes';

const initialSettings = {
  addTemplateModalVisible: false,
  noticeTemplateModal: {
    template: {},
    isLoading: false,
    visible: false,
  },
  carrierModal: {
    carrier: {},
    visible: false,
    isLoading: false,
  },
  carrierBusModal: {
    carrierId: null,
    bus: {},
    visible: false,
    isLoading: false,
  },
  carrierDriverModal: {
    carrierId: null,
    isSupervisor: false,
    driver: {},
    visible: false,
    isLoading: false,
  },
  sendNoticeModal: {
    routes: [],
    toRoute: false,
    visible: false,
    // Optional { body, header, type, diversionNotificationId } when the dialog
    // was opened with a prefilled DIVERSION cancel composer (task 09's
    // RouteDetails banner Cancel button). null otherwise.
    prefilledDiversion: null,
  },
  selectBusesAndDriversModal: {
    routeId: null,
    busesAndDrivers: {
      busesIds: [],
      driversIds: [],
    },
    visible: false,
    isLoading: false,
  },
  importDataModal: {
    visible: false,
    isLoading: false,
  },
  activationAccountModal: {
    roles: null,
    action: null,
    userId: null,
    visible: false,
    isLoading: false,
  },
  deleteAccountModal: {
    userId: null,
    visible: false,
    isLoading: false,
  },
  addAccountModal: {
    selectionModalVisible: false,
  },
  addStudentModal: {
    visible: false,
    userInfo: null,
    userId: null,
    isLoading: false,
  },
  parentStaffModal: {
    visible: false,
    userId: '',
    isLoading: false,
    users: [],
    pageCount: 1,
  },
  historyMapModal: {
    visible: false,
    mapData: null,
  },
  errorModal: {
    visible: false,
    errorMessage: '',
  },
};

const modal = (state = initialSettings, action) => {
  switch (action.type) {
    case SHOW_NOTICE_TEMPLATE_MODAL:
      return {
        ...state,
        noticeTemplateModal: {
          ...state.noticeTemplateModal,
          template: action.payload.template,
          visible: true,
        },
      };
    case SHOW_CARRIER_MODAL:
      return {
        ...state,
        carrierModal: {
          carrier: action.payload.carrier,
          visible: true,
        },
      };
    case SHOW_CARRIER_BUS_MODAL:
      return {
        ...state,
        carrierBusModal: {
          carrierId: action.payload.carrierId,
          bus: action.payload.bus,
          visible: true,
        },
      };
    case SHOW_CARRIER_DRIVER_MODAL:
      return {
        ...state,
        carrierDriverModal: {
          carrierId: action.payload.carrierId,
          isSupervisor: !!action.payload.driver.supervisorId,
          driver: action.payload.driver,
          visible: true,
        },
      };
    case SHOW_SEND_NOTICE_MODAL:
      return {
        ...state,
        sendNoticeModal: {
          ...state.sendNoticeModal,
          routes: action.payload.routes,
          toRoute: action.payload.toRoute,
          // Default to null when omitted so legacy 2-arg dispatches stay clean.
          prefilledDiversion: action.payload.prefilledDiversion || null,
          visible: true,
        },
      };
    case SHOW_SELECT_BUSES_AND_DRIVERS_MODAL: {
      return {
        ...state,
        selectBusesAndDriversModal: {
          ...state.selectBusesAndDriversModal,
          routeId: action.payload.routeId,
          busesAndDrivers: action.payload.busesAndDrivers,
          visible: true,
        },
      };
    }
    case UPDATE_ROUTE_RELATIONS: {
      return {
        ...state,
        selectBusesAndDriversModal: {
          ...state.selectBusesAndDriversModal,
          isLoading: true,
        },
      };
    }
    case HIDE_SELECT_BUSES_AND_DRIVERS_MODAL:
    case UPDATE_ROUTE_RELATIONS_SUCCESS: {
      return {
        ...state,
        selectBusesAndDriversModal: {
          ...state.selectBusesAndDriversModal,
          isLoading: false,
          visible: false,
        },
      };
    }
    case UPDATE_ROUTE_RELATIONS_FAILURE: {
      return {
        ...state,
        selectBusesAndDriversModal: {
          ...state.selectBusesAndDriversModal,
          isLoading: false,
        },
      };
    }
    case HIDE_NOTICE_TEMPLATE_MODAL:
      return {
        ...state,
        noticeTemplateModal: {
          ...state.noticeTemplateModal,
          template: {},
          visible: false,
        },
      };
    case HIDE_CARRIER_MODAL:
      return {
        ...state,
        carrierModal: {
          ...state.carrierModal,
          carrier: {},
          visible: false,
        },
      };
    case HIDE_CARRIER_BUS_MODAL:
      return {
        ...state,
        carrierBusModal: {
          carrierId: null,
          bus: {},
          visible: false,
        },
      };
    case HIDE_CARRIER_DRIVER_MODAL:
      return {
        ...state,
        carrierDriverModal: {
          carrierId: null,
          driver: {},
          visible: false,
        },
      };
    case HIDE_SEND_NOTICE_MODAL:
      return {
        ...state,
        sendNoticeModal: {
          ...state.sendNoticeModal,
          visible: false,
          // Drop the prefill on close — a subsequent open without a prefill
          // arg must NOT inherit a stale cancel-composer payload.
          prefilledDiversion: null,
        },
      };

    case REMOVE_DRIVER:
    case UPDATE_DRIVER:
    case CREATE_DRIVER: {
      return {
        ...state,
        carrierDriverModal: {
          ...state.carrierDriverModal,
          isSupervisor: action.payload.supervisor,
          isLoading: true,
        },
      };
    }
    case UPDATE_DRIVER_SUCCESS:
    case REMOVE_DRIVER_SUCCESS:
    case CREATE_DRIVER_SUCCESS: {
      return {
        ...state,
        carrierDriverModal: {
          ...state.carrierDriverModal,
          isLoading: false,
          visible: false,
        },
      };
    }

    case CREATE_CARRIER:
    case REMOVE_CARRIER:
    case UPDATE_CARRIER_DETAILS: {
      return {
        ...state,
        carrierModal: {
          ...state.carrierModal,
          isLoading: true,
        },
      };
    }
    case CREATE_CARRIER_SUCCESS:
    case REMOVE_CARRIER_SUCCESS:
    case UPDATE_CARRIER_DETAILS_SUCCESS: {
      return {
        ...state,
        carrierModal: {
          ...state.carrierModal,
          isLoading: false,
          visible: false,
        },
      };
    }
    case UPDATE_CARRIER_FAILURE: {
      return {
        ...state,
        carrierModal: {
          ...state.carrierModal,
          isLoading: false,
        },
      };
    }
    case CREATE_BUS:
    case UPDATE_BUS:
    case REMOVE_BUS: {
      return {
        ...state,
        carrierBusModal: {
          ...state.carrierBusModal,
          isLoading: true,
        },
      };
    }
    case CREATE_BUS_SUCCESS:
    case UPDATE_BUS_SUCCESS:
    case REMOVE_BUS_SUCCESS: {
      return {
        ...state,
        carrierBusModal: {
          ...state.carrierBusModal,
          isLoading: false,
          visible: false,
        },
      };
    }
    case UPDATE_DRIVER_FAILURE: {
      return {
        ...state,
        carrierDriverModal: {
          ...state.carrierDriverModal,
          isLoading: false,
        },
      };
    }
    case UPDATE_BUS_FAILURE: {
      return {
        ...state,
        carrierBusModal: {
          ...state.carrierBusModal,
          isLoading: false,
        },
      };
    }
    case ADD_NOTICE_TEMPLATE:
    case EDIT_NOTICE_TEMPLATE: {
      return {
        ...state,
        noticeTemplateModal: {
          ...state.noticeTemplateModal,
          isLoading: true,
        },
      };
    }
    case NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS: {
      return {
        ...state,
        noticeTemplateModal: {
          ...state.noticeTemplateModal,
          isLoading: false,
          visible: false,
        },
      };
    }
    case NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE: {
      return {
        ...state,
        noticeTemplateModal: {
          ...state.noticeTemplateModal,
          isLoading: false,
        },
      };
    }
    case SHOW_DEACTIVATE_ACCOUNT_MODAL: {
      return {
        ...state,
        activationAccountModal: {
          visible: true,
          roles: action.payload.roles,
          action: action.payload.action,
          userId: action.payload.userId,
        },
      };
    }
    case HIDE_DEACTIVATE_ACCOUNT_MODAL: {
      return {
        ...state,
        activationAccountModal: {
          visible: false,
          roles: null,
          action: null,
          userId: null,
        },
      };
    }
    case SHOW_DELETE_ACCOUNT_MODAL: {
      return {
        ...state,
        deleteAccountModal: {
          visible: true,
          userId: action.payload,
        },
      };
    }
    case HIDE_DELETE_ACCOUNT_MODAL: {
      return {
        ...state,
        deleteAccountModal: {
          visible: false,
          userId: null,
        },
      };
    }
    case SHOW_ADD_ACCOUNT_MODAL: {
      return {
        ...state,
        addAccountModal: {
          ...state.addAccountModal,
          selectionModalVisible: true,
        },
      };
    }
    case HIDE_ADD_ACCOUNT_MODAL: {
      return {
        ...state,
        addAccountModal: {
          ...state.addAccountModal,
          selectionModalVisible: false,
        },
      };
    }
    case SHOW_ADD_STUDENT_FORM: {
      return {
        ...state,
        addAccountModal: {
          ...state.addAccountModal,
          selectionModalVisible: false,
        },
        addStudentModal: {
          ...state.addStudentModal,
          visible: true,
          userId: action.payload.userId,
          backToDetails: action.payload.backToDetails,
        },
      };
    }
    case HIDE_ADD_STUDENT_FORM: {
      return {
        ...state,
        addStudentModal: {
          ...state.addStudentModal,
          visible: false,
          userInfo: null,
          userId: null,
        },
      };
    }
    case GET_STUDENT_INFO:
      return {
        ...state,
        addStudentModal: {
          ...state.addStudentModal,
          isLoading: true,
        },
      };
    case GET_STUDENT_INFO_SUCCESS:
      return {
        ...state,
        addStudentModal: {
          ...state.addStudentModal,
          userInfo: action.payload.data,
          isLoading: false,
        },
      };
    case GET_STUDENT_INFO_ERROR:
      return {
        ...state,
        addStudentModal: {
          ...state.addStudentModal,
          isLoading: false,
        },
      };
    case SHOW_PARENT_STAFF_MODAL: {
      return {
        ...state,
        addAccountModal: {
          ...state.addAccountModal,
          selectionModalVisible: false,
        },
        parentStaffModal: {
          ...state.parentStaffModal,
          visible: true,
          userId: action.payload.userId,
          isEditOnList: action.payload.editOnList,
        },
      };
    }
    case HIDE_PARENT_STAFF_MODAL: {
      return {
        ...state,
        parentStaffModal: {
          ...state.parentStaffModal,
          visible: false,
          userId: '',
        },
      };
    }

    case SEARCH_USERS_FORM:
      return {
        ...state,
        parentStaffModal: {
          ...state.parentStaffModal,
          isLoading: true,
        },
      };
    case SEARCH_USERS_FORM_SUCCESS:
      return {
        ...state,
        parentStaffModal: {
          ...state.parentStaffModal,
          pageCount: action.payload.pageCount,
          users: action.payload.users,
          isLoading: false,
        },
      };
    case SEARCH_USERS_FORM_ERROR:
      return {
        ...state,
        parentStaffModal: {
          ...state.parentStaffModal,
          isLoading: false,
        },
      };
    case ERROR_MODAL:
      return {
        ...state,
        errorModal: {
          ...state.errorModal,
          errorMessage: action.payload.errorMessage,
          visible: true,
        },
      };
    case HIDE_ERROR_MODAL:
      return {
        ...state,
        errorModal: {
          ...state.errorModal,
          visible: false,
        },
      };

    case SHOW_HISTORY_MAP_MODAL: {
      return {
        ...state,
        historyMapModal: {
          ...state.parentStaffModal,
          visible: true,
          mapData: action.payload,
        },
      };
    }

    case HIDE_HISTORY_MAP_MODAL: {
      return {
        ...state,
        historyMapModal: {
          ...state.parentStaffModal,
          visible: false,
          mapData: null,
        },
      };
    }

    default:
      return state;
  }
};

export default modal;
